export const environment = {
  production: true,
  environmentName: 'traficon',
  dirPrefix: 'traficon'
};
